import { FC } from 'react';
import { Typography } from '../../typography/Typography';
import { CollectionAuthorInfoProps } from '../types';
import { AuthorBadgeView } from './parts/AuthorBadgeView';
import { CollectionHeaderView } from './parts/CollectionHeaderView';

export const CollectionAuthorInfo: FC<CollectionAuthorInfoProps> = ({ collectionModel, view }) => {
    if (collectionModel?.defaultCollection) {
        return (
            <Typography
                variant="body"
                weight="bold"
                width="100%"
                overflow="hidden"
                style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
                {collectionModel.displayName}
            </Typography>
        );
    }

    if (!collectionModel?.author) {
        return null;
    }

    if (view === 'collectionHeader') {
        return <CollectionHeaderView collectionModel={collectionModel} />;
    }

    if (view === 'authorBadge') {
        return <AuthorBadgeView collectionModel={collectionModel} />;
    }

    return null;
};
